export default "__VITE_ASSET__86704f7b__"